import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface BulkActionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: 'disconnect' | 'delete' | null;
  selectedCount: number;
  onConfirm: () => void;
  isLoading: boolean;
}

export function BulkActionsDialog({
  open,
  onOpenChange,
  action,
  selectedCount,
  onConfirm,
  isLoading
}: BulkActionsDialogProps) {
  if (!action) return null;

  const actionConfig = {
    disconnect: {
      title: 'Disconnect Selected Accounts',
      description: `Are you sure you want to disconnect ${selectedCount} selected trading accounts? This will set their connection status to "disconnected" and update related bot accounts.`,
      confirmText: 'Disconnect',
      variant: 'default' as const
    },
    delete: {
      title: 'Delete Selected Accounts',
      description: `Are you sure you want to permanently delete ${selectedCount} selected trading accounts? This action cannot be undone and will remove all related data including bot accounts and trading records.`,
      confirmText: 'Delete',
      variant: 'destructive' as const
    }
  };

  const config = actionConfig[action];

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{config.title}</AlertDialogTitle>
          <AlertDialogDescription>{config.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className={config.variant === 'destructive' ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90' : ''}
          >
            {isLoading ? 'Processing...' : config.confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}